import { useEffect } from 'react';
import queryString from 'query-string';
import { useNavigate } from 'react-router-dom';
import { Modules, AuthRoutes } from '../enums';

interface URLParamProps {
  type: AuthRoutes | Modules;
  uri?: string;
  perPage?: number;
  page?: number;
  order?: string;
  orderBy?: string;
}

const useUrlParams = ({ type, uri, perPage, page, order, orderBy }: URLParamProps) => {
  let url: string;
  let searchQuery;
  let watchList: any;
  let searchObject: any;
  const navigate = useNavigate();

  url = `${uri}`;
  watchList = [perPage, page, order, orderBy];
  searchObject = {
    perPage,
    page,
    order,
    orderBy,
  };

  useEffect(() => {
    searchQuery = queryString.stringify(searchObject);
    navigate(`${url}?${searchQuery}`, { replace: true });
  }, watchList);
};

export default useUrlParams;
